var switchSvg = {
    base: {
        overflow: "visible",
        "*": { transition: "all 0.2s linear" },
        opacity: 1,
        ".base": {
            fill: "black.20",
        },
        ".check": {
            // stroke: "primary.100",
            stroke: "white",
        },
        ".focusBorder": {
            display: "none",
            stroke: "primary.100",
        },
        ".focusRing": {
            display: "none",
            fill: "focus.shadow",
            transformOrigin: "center",
        },
    },
    variants: {
        isFocused: {
            true: {
                ".focusBorder": { display: "block" },
                ".focusRing": {
                    display: "block",
                },
            },
        },
        isChecked: {
            true: {
                ".base": {
                    fill: "primary.100",
                },
                ".knob-group": {
                    transform: "translateX(32px)",
                },
                ".check": {
                    stroke: "primary.100",
                },
            },
        },
        isDisabled: {
            true: {
                opacity: 0.5,
            },
        },
        size: {
            sm: {
                // 40px x 24px
                height: "29px",
                ".focusRing": {
                    transform: "scale(1.05)",
                },
                ".focusBorder": { strokeWidth: 2.3 },
            },
            md: {
                // 50px x 30px
                height: "36px",
                ".focusRing": {
                    transform: "scale(1.02)",
                },
                ".focusBorder": { strokeWidth: 2 },
            },
            lg: {
                // 56px x 34px
                height: "41px",
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

export { switchSvg };
//# sourceMappingURL=switch-svg.js.map
